module.exports = __webpack_public_path__ + "static/media/history-track-long.f74026c1.svg";